import { Record, List } from 'immutable'

const Card = Record({
  number:null,
  cvc: null,
  exp_month: null,
  exp_year:null
});
export default Card;



// WEBPACK FOOTER //
// ./src/vo/Card.js